const Card = ({ program }) => {
  return (
    <div className="card" key={program.id}>
      <div className="img">
        <img src={program.image || "/placeholder.svg"} alt={program.title} />
        {program.location ? (
          <span className="badge">{program.location}</span>
        ) : (
          <span className="badge">{program.category}</span>
        )}
      </div>

      <div className="body">
        <div className="dateAndTime">
          {program.date && (
            <p>
              <span>
                <i className="ri-calendar-line mr-2"></i>
              </span>{" "}
              {program.date}
            </p>
          )}
          {program.date && (
            <p>
              <span>
                <i className="ri-time-line mr-2"></i>{" "}
              </span>
              {program.duration}
            </p>
          )}
        </div>
        <h2>{program.title}</h2>
        <p>{program.description}</p>

        <div className="stats">
          <div>
            <span>
              <i className="ri-user-line mr-2"></i>
            </span>
            <span>
              {program.participants ? program.participants : program.user}
            </span>
            <span>{program.username && program.username}</span>
          </div>
          {program.participants && (
            <div>
              <span>
                <i className="ri-time-line mr-2"></i>{" "}
              </span>
              <span>{program.duration}</span>
            </div>
          )}
        </div>

        {program.participants && (
          <button className="btn-primary">Learn More</button>
        )}
      </div>
    </div>
  );
};

export default Card;
